import { render, staticRenderFns } from "./CompGallery.vue?vue&type=template&id=7aab1f37&scoped=true"
import script from "./CompGallery.vue?vue&type=script&lang=js"
export * from "./CompGallery.vue?vue&type=script&lang=js"
import style0 from "./CompGallery.vue?vue&type=style&index=0&id=7aab1f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab1f37",
  null
  
)

export default component.exports